import type { Theme } from '@mui/material/styles';

import { useSidebar } from '@src/app/layout';
import { useAuthentication } from '@src/features/auth';
import Avatar from '@src/shared/ui/Avatar';
import { Box } from '@src/shared/ui/layout';
import Link from '@src/shared/ui/Link';
import Typography from '@src/shared/ui/Typography';

const StyleSheet = {
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    '&:hover .MuiAvatar-root': {
      backgroundColor: 'primary.light',
    },
  },
  avatar: (theme: Theme) => ({
    backgroundColor: 'primary.main',
    borderRadius: '50%',
    fontSize: '1rem',
    fontWeight: 500,
    mr: 1.5,
    height: 36,
    width: 36,
    transition: theme.transitions.create('background-color'),
    '& .MuiSvgIcon-root': {
      color: 'common.white',
    },
  }),
  info: {
    width: 'calc(100% - 48px)',
  },
  typografy: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

function UserInfo() {
  const sidebar = useSidebar();
  const { user } = useAuthentication();
  const initials = user?.initials;

  return (
    <Box component={Link} to="/profile" underline="none" sx={StyleSheet.container}>
      <Avatar src={user?.portrait || undefined} sx={StyleSheet.avatar}>
        {initials}
      </Avatar>

      {sidebar?.isExpanded && (
        <Box sx={StyleSheet.info}>
          <Typography
            variant="h5"
            component="div"
            sx={StyleSheet.typografy}
          >
            {user?.name}
          </Typography>
          <Typography
            variant="body4"
            component="div"
            color="text.secondary"
            sx={StyleSheet.typografy}
          >
            {user?.email}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default UserInfo;
